// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Nunito-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("Nunito-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("Nunito-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("Nunito-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("Nunito-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("Nunito-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("Nunito-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("Nunito-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("Nunito-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("Nunito-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("Nunito-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("Nunito-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("Nunito-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("Nunito-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("Nunito-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("Nunito-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("Nunito-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("Nunito-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("Nunito-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("Nunito-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("Nunito-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("Nunito-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("Nunito-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("Nunito-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Nunito';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}


@font-face {
    font-family: 'Nunito';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}


@font-face {
    font-family: 'Nunito';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Nunito';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
}


@font-face {
    font-family: 'Nunito';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Nunito';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Nunito';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('truetype');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Nunito';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

`, "",{"version":3,"sources":["webpack://./src/assets/fonts/nunito/font3.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB;;kEAE6C;IAC7C,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,qBAAqB;IACrB;;kEAE8C;IAC9C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,qBAAqB;IACrB;;kEAEkD;IAClD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB;;mEAEmD;IACnD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,qBAAqB;IACrB;;mEAE8C;IAC9C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB;;mEAEgD;IAChD,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB;;mEAEiD;IACjD,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB;;mEAE+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: 'Nunito';\n    src: url('Nunito-Bold.woff2') format('woff2'),\n        url('Nunito-Bold.woff') format('woff'),\n        url('Nunito-Bold.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n\n@font-face {\n    font-family: 'Nunito';\n    src: url('Nunito-Black.woff2') format('woff2'),\n        url('Nunito-Black.woff') format('woff'),\n        url('Nunito-Black.ttf') format('truetype');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n\n\n@font-face {\n    font-family: 'Nunito';\n    src: url('Nunito-ExtraBold.woff2') format('woff2'),\n        url('Nunito-ExtraBold.woff') format('woff'),\n        url('Nunito-ExtraBold.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Nunito';\n    src: url('Nunito-ExtraLight.woff2') format('woff2'),\n        url('Nunito-ExtraLight.woff') format('woff'),\n        url('Nunito-ExtraLight.ttf') format('truetype');\n    font-weight: 200;\n    font-style: normal;\n    font-display: swap;\n}\n\n\n@font-face {\n    font-family: 'Nunito';\n    src: url('Nunito-Light.woff2') format('woff2'),\n        url('Nunito-Light.woff') format('woff'),\n        url('Nunito-Light.ttf') format('truetype');\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Nunito';\n    src: url('Nunito-Regular.woff2') format('woff2'),\n        url('Nunito-Regular.woff') format('woff'),\n        url('Nunito-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Nunito';\n    src: url('Nunito-SemiBold.woff2') format('woff2'),\n        url('Nunito-SemiBold.woff') format('woff'),\n        url('Nunito-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Nunito';\n    src: url('Nunito-Medium.woff2') format('woff2'),\n        url('Nunito-Medium.woff') format('woff'),\n        url('Nunito-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
